// range-slider.js FINAL — recuerda posición, espera visibilidad y no actualiza en movimiento

!function () {
  "use strict";

  const SELECTOR_SIDEBAR = "[data-collection-sidebar]";
  const SELECTOR_LEFT = "[data-range-left]";
  const SELECTOR_RIGHT = "[data-range-right]";
  const SELECTOR_LINE = "[data-range-line]";
  const SELECTOR_HOLDER = "[data-range-holder]";
  const ATTR_MIN = "data-se-min";
  const ATTR_MAX = "data-se-max";
  const ATTR_MIN_VALUE = "data-se-min-value";
  const ATTR_MAX_VALUE = "data-se-max-value";
  const ATTR_STEP = "data-se-step";
  const ATTR_UPDATE = "data-range-filter-update";
  const SELECTOR_MIN_FIELD = "[data-field-price-min]";
  const SELECTOR_MAX_FIELD = "[data-field-price-max]";
  const CLASS_INITIALIZED = "is-initialized";

  if (customElements.get("range-slider")) return;

  customElements.define("range-slider", class extends HTMLElement {
    constructor() {
      super();
      this.sidebar = this.closest(SELECTOR_SIDEBAR);
      const observer = new ResizeObserver(() => {
        if (this.offsetWidth > 0) {
          this.initializeSlider();
          observer.disconnect();
        }
      });
      observer.observe(this);
    }

    initializeSlider() {
      this.touchLeft = this.querySelector(SELECTOR_LEFT);
      this.touchRight = this.querySelector(SELECTOR_RIGHT);
      this.lineSpan = this.querySelector(SELECTOR_LINE);
      if (!this.touchLeft || !this.touchRight || !this.lineSpan) return;

      this.min = parseFloat(this.getAttribute(ATTR_MIN));
      this.max = parseFloat(this.getAttribute(ATTR_MAX));
      this.step = parseFloat(this.getAttribute(ATTR_STEP)) || 1;
      this.normalizeFact = 26;

      const currentMin = parseFloat(this.getAttribute(ATTR_MIN_VALUE)) || this.min;
      const currentMax = parseFloat(this.getAttribute(ATTR_MAX_VALUE)) || this.max;

      this.setMinValue(currentMin);
      this.setMaxValue(currentMax);

      this.selectedTouch = null;
      this.startX = 0;
      this.x = 0;

      const start = (e) => this.onStart(e);
      this.touchLeft.addEventListener("mousedown", start);
      this.touchRight.addEventListener("mousedown", start);
      this.touchLeft.addEventListener("touchstart", start, { passive: false });
      this.touchRight.addEventListener("touchstart", start, { passive: false });

      this.classList.add(CLASS_INITIALIZED);
    }

    setMinValue(val) {
      const percent = (val - this.min) / (this.max - this.min);
      this.touchLeft.style.left = Math.ceil(percent * (this.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact))) + "px";
      this.updateLine();
      this.setAttribute(ATTR_MIN_VALUE, val);
    }

    setMaxValue(val) {
      const percent = (val - this.min) / (this.max - this.min);
      this.touchRight.style.left = Math.ceil(percent * (this.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact)) + this.normalizeFact) + "px";
      this.updateLine();
      this.setAttribute(ATTR_MAX_VALUE, val);
    }

    updateLine() {
      this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px";
      this.lineSpan.style.width = (this.touchRight.offsetLeft - this.touchLeft.offsetLeft) + "px";
    }

    onStart(event) {
      const e = event.touches ? event.touches[0] : event;
      if (event.cancelable) event.preventDefault();

      this.selectedTouch = event.currentTarget;
      this.x = this.selectedTouch.offsetLeft;
      this.startX = e.pageX - this.x;

      document.addEventListener("mousemove", this.onMoveBound = (ev) => this.onMove(ev));
      document.addEventListener("mouseup", this.onStopBound = () => this.onStop());
      document.addEventListener("touchmove", this.onMoveBound, { passive: false });
      document.addEventListener("touchend", this.onStopBound);
    }

    onMove(event) {
      const e = event.touches ? event.touches[0] : event;
      if (event.cancelable) event.preventDefault();

      this.x = e.pageX - this.startX;
      const maxX = this.offsetWidth - this.touchRight.offsetWidth;

      if (this.selectedTouch === this.touchLeft) {
        this.x = Math.min(Math.max(0, this.x), this.touchRight.offsetLeft - this.touchLeft.offsetWidth);
        this.touchLeft.style.left = this.x + "px";
      } else if (this.selectedTouch === this.touchRight) {
        this.x = Math.max(this.touchLeft.offsetLeft + this.touchLeft.offsetWidth, Math.min(this.x, maxX));
        this.touchRight.style.left = this.x + "px";
      }

      this.updateLine();
    }

    onStop() {
      document.removeEventListener("mousemove", this.onMoveBound);
      document.removeEventListener("mouseup", this.onStopBound);
      document.removeEventListener("touchmove", this.onMoveBound);
      document.removeEventListener("touchend", this.onStopBound);
      this.selectedTouch = null;
      this.calculateValue();
    }

    calculateValue() {
      const totalWidth = this.offsetWidth - this.touchLeft.offsetWidth;
      const minPercent = this.touchLeft.offsetLeft / totalWidth;
      const maxPercent = this.touchRight.offsetLeft / totalWidth;
      let min = Math.round(this.min + (this.max - this.min) * minPercent);
      let max = Math.round(this.min + (this.max - this.min) * maxPercent);

      if (this.step > 0) {
        min = Math.round(min / this.step) * this.step;
        max = Math.round(max / this.step) * this.step;
      }

      min = Math.max(this.min, Math.min(min, max));
      max = Math.min(this.max, Math.max(max, min));

      this.setAttribute(ATTR_MIN_VALUE, min);
      this.setAttribute(ATTR_MAX_VALUE, max);

      const holder = this.closest(SELECTOR_HOLDER);
      if (holder) {
        const minField = holder.querySelector(SELECTOR_MIN_FIELD);
        const maxField = holder.querySelector(SELECTOR_MAX_FIELD);
        if (minField) minField.value = min;
        if (maxField) maxField.value = max;
      }

      if (this.hasAttribute(ATTR_UPDATE)) {
        this.dispatchEvent(new CustomEvent("theme:range:update", { bubbles: true }));
      }
    }

    disconnectedCallback() {
      document.removeEventListener("theme:resize:width", this.resizeEvent);
    }
  });
}();
